import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { afterItems, beforeItems } from '../../data/content';
export function BeforeAfterSection() {
  return <section aria-labelledby="compare-heading" className="bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-24" data-id="element-57" data-mp="1xotplp3yhhkw">
      <div className="mx-auto max-w-5xl" data-id="element-58" data-mp="22nwy5jj5a5xm">
        <SectionHeading id="compare-heading" title="Weniger zusammensuchen. Mehr gezielt vorbereiten." data-id="element-59" data-mp="22qsux4j9aokh" />

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-60" data-mp="1ny8x8jevl9af">
          <div className="rounded-[20px] bg-brand-ivory/70 p-7 sm:p-9" data-id="element-61" data-mp="1srleu9l50fto">
            <h3 className="font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-charcoal/55" data-id="element-62" data-mp="1f06mvd9954ah">
              Ohne strukturierte Materialsammlung
            </h3>
            <ul className="mt-6 space-y-3.5" role="list" data-id="element-63" data-mp="151hfieezf28h">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-brand-charcoal/60" data-id="element-64" data-mp="1a0112dpnyc0b">
                  <XIcon className="mt-0.5 h-4 w-4 flex-none text-[#B5655E]" strokeWidth={2.25} aria-hidden="true" data-id="element-65" data-mp="276xf1x1jmw8q" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-[20px] border-2 border-brand-cta/40 bg-white p-7 shadow-[0_30px_60px_-40px_rgba(41,69,50,0.55)] sm:p-9" data-id="element-66" data-mp="2g7de8ub97h7s">
            <h3 className="font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-cta" data-id="element-67" data-mp="2c4p3gh2zc086">
              Mit Nail Educator Ready™
            </h3>
            <ul className="mt-6 space-y-3.5" role="list" data-id="element-68" data-mp="1jj72zojttqkj">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3 text-[15px] font-medium leading-snug text-brand-charcoal" data-id="element-69" data-mp="1xakjetmfu8bc">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand-cta" strokeWidth={2.5} aria-hidden="true" data-id="element-70" data-mp="1shj2kg2o7yp4" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}